import { createPortal } from 'react-dom';
import { AlertTriangle, CheckCircle2, CircleAlert, Info, X } from 'lucide-react';
import styles from './Toast.module.scss';

const TONE_ICONS = {
  error: CircleAlert,
  success: CheckCircle2,
  warning: AlertTriangle,
  info: Info,
};

let toastRoot = null;

const getToastRoot = () => {
  if (!toastRoot) {
    toastRoot = document.createElement('div');
    toastRoot.className = styles.toastRoot;
    document.body.appendChild(toastRoot);
  }
  return toastRoot;
};

// Floating notification pinned to the top of the viewport so feedback stays
// visible regardless of scroll position. Render it conditionally, like the
// inline banners it replaces: {error && <Toast tone="error">{error}</Toast>}
function Toast({ tone = 'info', icon, onClose, children }) {
  const IconComponent = TONE_ICONS[tone] || TONE_ICONS.info;
  return createPortal(
    <div
      className={`${styles.toast} ${styles[tone] || styles.info}`}
      role={tone === 'error' ? 'alert' : 'status'}
    >
      {icon || <IconComponent size={16} />}
      <div className={styles.body}>{children}</div>
      {onClose && (
        <button type="button" className={styles.close} onClick={onClose} aria-label="Dismiss">
          <X size={14} />
        </button>
      )}
    </div>,
    getToastRoot()
  );
}

export default Toast;
